import { type OlkAcceleratorGrowthErrorCodes } from "owa-error-codes";
import type { PerformanceDatapoint } from "owa-analytics";
import { DatapointStatus } from "owa-analytics";
import { isExecuting } from "./isExecuting";

import type { CustomData, TraceErrorObject } from "owa-analytics-types";

export function actActionIfExecuting(datapoint: PerformanceDatapoint | undefined, customData: CustomData, action?: "end" | "invalidate" | "endWithError", errorObject?: TraceErrorObject, errorStatus?: DatapointStatus): void {
    if (isExecuting(datapoint)) {
        datapoint.addCustomData(customData);
        
        if (action === "end") {
            datapoint.end();
        }
        else if (action === "endWithError") {
            datapoint.endWithError(errorStatus || DatapointStatus.ServerError, errorObject ?? "01_0066");
        }
        else if (action === "invalidate") {
            datapoint.invalidate();
        }
    }
}
